// CANONICAL COPY (GH #7115). src/constants/obligations/obl-cra-technical-documentation.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-cra-technical-documentation',
  title: 'Maintain and retain CRA technical documentation for 10 years',
  description:
    'For each product with digital elements (PDE) that is in scope, the manufacturer must draw up technical documentation in accordance with CRA Art. 31 and Annex VII before placing the PDE on the market, keep it up to date during the support period, and retain it for at least 10 years (Art. 13(4), 13(18)). A reference to the technical documentation must be recorded per product.',
  category: 'compliance',
  scfIds: ['SCF-GOV-011', 'SCF-AUD-002'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'per-product',
  perProductCriteria: [
    { type: 'product-tech-doc-set', description: 'Technical documentation reference set' },
  ],
  domainActions: [],
};
